import { useState } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

function useLoadFullPanchangData() {
  const [fullpanchang, setFullPanchang] = useState(null);
  const getPanchangData = async () => {
    const response = await getApi(apiEndPoints?.getFullPagePanchang);
    setFullPanchang(
      response?.data?.data?.map((item) => ({
        title: "Panchang Event",
        start: item?.start,
        extendedProps: {
          html: item?.customHtml,
        },
      }))
    );
  };

  return {
    fullpanchang,
    getPanchangData,
  };
}

export default useLoadFullPanchangData;
